export class RequestResult {
    public result: boolean;
    public value: any;

    constructor(res: boolean, v?: any) {
        this.result = res;
        this.value = v;
    }
}

export class RequestResultValue<T> {
    public result: boolean;
    public value?: T;

    constructor(res: boolean, v?: T) {
        this.result = res;
        if (v != null) {
            this.value = v;
        }
    }
}

export interface NoContentResponse extends ResponseBase<string> { }

export interface ResponseBase<T> {
    success: boolean,
    data?: T,
    error?: ResponseError
}

export interface ResponseError {
    code: number,
    description?: string
}